export default {
notification: {
  read: "Nabasa",
  unread: "Hindi pa nababasa",
  hide: "Itago",
  showAll: "Ipakita lahat",
  loading: "Naglo-load...",
  noMore: "Wala nang data",
  platform: "Plataporma",
  personal: "Personal"
}
};
